import { MUNICIPAL_PROPERTY_BASE_PATH } from "@/domain/municipal-property/routes/municipal-property-base-path";

// Literal union so the strictly-typed `t` accepts a descriptor's key directly.
type EntityTypeLabelKey =
  | "admin.entityType.CLIMATE_ACTION"
  | "admin.entityType.PROJECT"
  | "admin.entityType.TASK"
  | "admin.entityType.INVENTORY"
  | "admin.entityType.MUNICIPAL_PROPERTY_REGISTER"
  | "admin.entityType.SCENARIO_MODEL"
  | "admin.entityType.INDICATOR"
  | "admin.entityType.DASHBOARD";

interface EntityRouteDescriptor {
  readonly entityType: string;
  readonly segment: string;
  readonly pathPrefix?: string;
  readonly labelKey: EntityTypeLabelKey;
  readonly pathSuffix?: string;
}

export const ENTITY_ROUTE_DESCRIPTOR_LIST: readonly EntityRouteDescriptor[] = [
  { entityType: "CLIMATE_ACTION", segment: "climate-actions", labelKey: "admin.entityType.CLIMATE_ACTION" },
  { entityType: "PROJECT", segment: "projects", labelKey: "admin.entityType.PROJECT" },
  { entityType: "TASK", segment: "tasks", labelKey: "admin.entityType.TASK" },
  { entityType: "INVENTORY", segment: "inventories", labelKey: "admin.entityType.INVENTORY" },
  {
    entityType: "MUNICIPAL_PROPERTY_REGISTER",
    segment: "registers",
    pathPrefix: MUNICIPAL_PROPERTY_BASE_PATH,
    labelKey: "admin.entityType.MUNICIPAL_PROPERTY_REGISTER",
  },
  { entityType: "SCENARIO_MODEL", segment: "scenarios", labelKey: "admin.entityType.SCENARIO_MODEL" },
  { entityType: "INDICATOR", segment: "indicators", labelKey: "admin.entityType.INDICATOR" },
  {
    entityType: "DASHBOARD",
    segment: "public-dashboards",
    labelKey: "admin.entityType.DASHBOARD",
    pathSuffix: "edit",
  },
] as const;
